import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { AwardIcon, CheckCircleIcon } from 'lucide-react';
import { SectionDivider } from '../components/SectionDivider';
const ANDREEA_PHOTO = 'https://cdn.magicpatterns.com/uploads/9gj5iqrEkvf8RHnMKQ6fGs/poza1.jpg';
const certifications = ['Facultatea de Drept – Licența în Drept', 'Specializare Dreptul Familiei – Divorț, Partaj, Autoritate Părintească', 'Curs „Data Protection and Privacy Rights" – Programul European HELP', 'Seminar „Procedural Rules in European Criminal Law" – Consiliul Superior al Magistraturii', 'Curs „Representation of Children with Disabilities" – Centrul de Resurse Juridice'];
export function DespreMine() {
  return <div className="w-full" data-id="element-359">
      {/* HERO DESPRE MINE */}
      <section className="bg-navy diagonal-pattern py-20 px-6" data-id="element-360">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-361">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="relative flex justify-center order-2 md:order-1" data-id="element-362">
            <div className="relative" data-id="element-363">
              <div className="absolute -inset-8 bg-emerald/15 rounded-[30%_70%_70%_30%/30%_30%_70%_70%] blur-sm" data-id="element-364"></div>
              <div className="absolute -top-5 -right-5 w-28 h-28 border border-gold/25 rounded-full z-0" data-id="element-365"></div>
              <div className="absolute -bottom-8 -left-8 w-36 h-36 border border-gold/15 rounded-full z-0" data-id="element-366"></div>
              <div className="relative gold-corner-frame" data-id="element-367">
                <img src={ANDREEA_PHOTO} alt="Andreea Saveli - Avocat Dreptul Familiei" className="relative z-10 w-full max-w-md h-[560px] object-cover object-top rounded-lg shadow-2xl shadow-navy/50" data-id="element-368" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="order-1 md:order-2" data-id="element-369">
            <div className="text-gold font-label text-xs uppercase tracking-label mb-6" data-id="element-370">
              AVOCAT · DREPTUL FAMILIEI
            </div>
            <h1 className="text-text-light font-heading text-5xl md:text-6xl font-bold mb-4" data-id="element-371">
              Andreea Saveli
            </h1>
            <p className="text-gold font-label text-xs uppercase tracking-label mb-8" data-id="element-372">
              Avocat Dreptul Familiei · Divorț · Partaj · Moșteniri · Drept
              Penal Familial · 23 de ani de experiență
            </p>
            <p className="text-text-light font-body text-lg italic leading-relaxed border-l-2 border-emerald pl-6" data-id="element-373">
              „Nu sunt avocatul care îți spune că totul va fi bine ca să te
              liniștească. Sunt avocatul care îți spune exact cum stau
              lucrurile, ce poți obține și ce urmează, pentru că claritatea este
              cel mai mare cadou pe care ți-l pot oferi într-un moment atât de
              dificil."
            </p>
          </motion.div>
        </div>
      </section>

      {/* DE CE FAC CE FAC */}
      <section className="bg-cream py-20 px-6" data-id="element-374">
        <div className="max-w-4xl mx-auto" data-id="element-375">
          <h2 className="text-text-dark font-heading text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-376">
            De ce am ales să lucrez în dreptul familiei
          </h2>
          <div className="space-y-5 font-body text-lg text-text-dark-secondary leading-relaxed" data-id="element-377">
            <p data-id="element-378">
              Mulți oameni ajung la mine după ce au stat luni sau ani în locul
              în care sunt, paralizați de frici care în realitate nu corespund
              cu legea. Li se spune că vor pierde tot, că nu au nicio șansă, că
              legea nu îi protejează.
            </p>
            <p data-id="element-379">
              Realitatea pe care am văzut-o în 23 de ani de practică este
              diferită: drepturile lor există, sunt clare și pot fi obținute.
            </p>
            <p data-id="element-380">
              Tocmai de aceea am ales să rămân în acest domeniu. Nu pentru că e
              ușor, ci pentru că schimbarea care se întâmplă în viața unui
              client atunci când înțelege că nu este singur și că legea lucrează
              pentru el nu se compară cu nimic altceva.
            </p>
          </div>
        </div>
      </section>

      <div className="bg-cream" data-id="element-381">
        <SectionDivider data-id="element-382" />
      </div>

      {/* ACREDITĂRI */}
      <section className="bg-cream py-20 px-6" data-id="element-383">
        <div className="max-w-4xl mx-auto" data-id="element-384">
          <h2 className="text-text-dark font-heading text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-385">
            Formare profesională și specializare
          </h2>
          <p className="text-text-dark-secondary font-body text-lg leading-relaxed text-center max-w-3xl mx-auto mb-12" data-id="element-386">
            Lucrez într-un cadru etic și confidențial, cu o specializare
            practică de 23 de ani exclusiv în dreptul familiei și domeniile
            conexe.
          </p>
          <div className="space-y-4" data-id="element-387">
            {certifications.map((cert, i) => <div key={i} className="bg-white rounded-lg p-6 border-l-[3px] border-emerald shadow-[0_4px_20px_rgba(12,35,64,0.08)] flex items-start gap-4" data-id="element-388">
                <AwardIcon className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-389" />
                <p className="font-body text-base text-text-dark leading-relaxed" data-id="element-390">
                  {cert}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="bg-navy diagonal-pattern py-20 px-6" data-id="element-391">
        <div className="max-w-3xl mx-auto text-center" data-id="element-392">
          <h2 className="text-text-light font-heading text-3xl md:text-4xl font-bold mb-6" data-id="element-393">
            Ai întrebări la care nu ai primit încă un{' '}
            <span className="text-gold" data-id="element-394">răspuns sincer</span>?
          </h2>
          <p className="text-text-light-secondary font-body text-lg leading-relaxed mb-8" data-id="element-395">
            Rezervă o sesiune de claritate în care îți explic exact ce îți
            garantează legea în situația ta. Fără presiune, fără termeni
            juridici grei. Suma se aplică integral la pachetul ales dacă decidem
            să continuăm.
          </p>
          <Link to="/contact" className="inline-block bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors mb-4" data-id="element-396">
            Rezervă Sesiunea de Claritate
          </Link>
          <p className="text-text-light-secondary font-body text-sm" data-id="element-397">
            Sesiunea se desfășoară online. Disponibilitate de luni până vineri.
          </p>
        </div>
      </section>
    </div>;
}